export function isEmailLike(value) {
    return /^[^@]+@[^.@]+\.[^.@]+[^@]*$/.test(value);
}
